import jQuery from 'jquery';

/**
 * Class which adds / removes Classes from the body, based on a ajax call. To Cachebust the caching plugin.
 */
export default class AjaxClasses {
  constructor() {
    this.ajax_url = ajax.url;

    if (!this.ajax_url) {
      return;
    }

    this.post_id = ajax.post_id;
    this.classes = [];
    this.ajax();
  }

  ajax() {
    jQuery.ajax({
      type: 'GET',
      dataType: 'json',
      url: this.ajax_url,
      data: {
        'post_id': this.post_id,
        'action': 'js_body_classes',
      },
      success: function (response) {

        // Nothing to see here if doesn't match.
        if (!response || !response.success || !response.data || !response.data.add) {
          return;
        }

        // Loop through classes and add missing ones.
        Object.entries(response.data.add).forEach(name => {
          if (document.body.classList.contains(name)) {
            document.body.classList.add(name);
          }
        });

        // Check if not empty.
        if (response.data.remove) {
          // Loop trough classes which must be removed.
          Object.entries(response.data.remove).forEach(name => {
            if (document.body.classList.contains(name)) {
              document.body.classList.remove(name);
            }
          });
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('Error: ', jqXHR, textStatus, errorThrown);
      }
    });
  }
}
